module.exports = __webpack_public_path__ + "img/premiro.de617279.png";